import * as Sentry from '@sentry/react'
import { createError } from './error'

interface HttpOptions {
    accessToken?: string
    body?: unknown
    headers?: Record<string, string>
    [key: string]: unknown
}

export const httpUtil = (url: string, options: HttpOptions = {}) => {
    const defaultHeaders: Record<string, string> = {
        'Content-Type': 'application/json'
    }
    const { accessToken, body, ...fetchSettings } = options

    let requestBody: string | undefined
    if (typeof body === 'object') {
        requestBody = JSON.stringify(body)
    } else if (typeof body === 'string') {
        requestBody = body
    }

    return fetch(url, {
        mode: 'cors',
        ...fetchSettings as RequestInit,
        body: requestBody,
        headers: {
            ...defaultHeaders,
            ...(fetchSettings.headers ? fetchSettings.headers as Record<string, string> : {}),
            ...(accessToken ? {
                'Authorization': `Bearer ${accessToken}`,
            } : {})

        },
    })
    .catch((error) => {
        const appError = createError(`${error.message}: ${url}`, 502)
        Sentry.captureException(appError, { tags: { errorType: 'network', url }})
        throw appError
    })
    .then((response) => {
        if (!response.ok) {
            const appError = createError(response.statusText, response.status)
            if (response.status >= 500) {
                Sentry.captureException(appError, { tags: { errorType: 'api', url, status: String(response.status) }})
            }
            throw appError
        }
        return response.json()
    })
}
